import { instance } from '@/libs/api/instance'

/**
 * Get list of reports
 *
 * @param {string} [description] - use for filtering by 'report.description' filed
 * @return {Promise<import('axios').AxiosResponse<any>>}
 */

export const getList = async ({ description = '' }) => {
  return instance.get('/v2/wallet/report', {
    params: { description },
  })
}
